import React from 'react';
import * as styles from './StatusIndicator.module.css';

type StatusIndicatorProps = {
  completed: boolean;
};
export function StatusIndicator({
  completed,
}: StatusIndicatorProps): JSX.Element {
  return <span className={completed ? styles.complete : styles.draft} />;
}
